/* Skyla Rose Fitting Room: try-on tracking (added 22 Oct 2026)
   Marks the shopper's cart when they use the try-on, so it shows on their order
   (Shopify admin > order > Additional details):
   - _tryon_opened: yes        they opened the fitting room
   - _tryon_used: yes          they got a try-on look back
   - _tryon_products: handles  which pieces they tried on this visit
   - _tryon_video: yes         they tapped "See it move"
   Attributes starting with _ are hidden from the shopper at checkout.
   Also sends "Opened Try-On" and "Used Try-On" events to Klaviyo for shoppers Klaviyo already knows. */
(function(){
  if (window.SaroTryonTrack) return;
  window.SaroTryonTrack = true;

  function recall(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function store(k, v){ try { sessionStorage.setItem(k, v); } catch(e){} }
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function stamp(attrs){
    try {
      return fetch(base + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function(){});
    } catch(e){}
  }
  function klaviyo(name, props){
    try { var k = window.klaviyo || window._learnq; if (k && k.push) k.push(['track', name, props]); } catch(e){}
  }
  function tried(handle){
    var list = (recall('saro_tryon_tried') || '').split(',').filter(Boolean);
    if (handle && list.indexOf(handle) < 0) list.push(handle);
    store('saro_tryon_tried', list.join(','));
    return list.join(', ');
  }

  function init(root){
    if (!root || root.dataset.trackReady) return;
    root.dataset.trackReady = '1';
    var handle = root.dataset.product || '';
    var kids = root.dataset.kids === 'true';

    root.addEventListener('click', function(e){
      if (e.target.closest('.saro-tryon__open')) {
        stamp({ _tryon_opened: 'yes' });
        klaviyo('Opened Try-On', { Product: handle, Kids: kids });
      }
      if (e.target.closest('.saro-tryon__tab[data-view="video"]')) stamp({ _tryon_video: 'yes' });
    }, true);

    // Fires each time a try-on look comes back (not again for shoe or styling tweaks)
    root.addEventListener('saro:look', function(e){
      if (e.detail && (e.detail.styled || e.detail.paired)) return;
      stamp({ _tryon_opened: 'yes', _tryon_used: 'yes', _tryon_products: tried(handle) });
      klaviyo('Used Try-On', { Product: handle, Kids: kids });
    });
  }

  function scan(){ document.querySelectorAll('.saro-tryon[data-api]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1500);
})();
